import { IDefineCommand } from 'core-ts-types';
import { IDatasource, ORM } from 'utility-ts-orm';
import { HoldType } from './../builders/holdtype_builder';
angular
  .module('capability-ng-holds')
  .factory(
    'loadHoldResolutionCommand',
    function loadHoldResolutionCommandDefinition(
      $q: ng.IQService,
      $http: ng.IHttpService,
      defineCommand: IDefineCommand,
      ngHoldTypeDatastore: IDatasource<HoldType>
    ) {
      return defineCommand(
        'loadHoldResolutionCommand',
        function loadHoldResolutionCommand(deferred: any, studentHoldId: string) {
          $http
            .get('holds/holdtype/' + studentHoldId)
            .then(({ data }: { data: HoldType }) => {
              deferred.resolve(ngHoldTypeDatastore.put(data));
            })
            .catch((error: any) => {
              deferred.reject(error);
            });
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-holds/src/commands/load_hold_resolutions_command.ts